import type { Product } from "../types/product";

export const products: Product[] = [
  {
    id: "1",
    name: "Cat Print T-Shirt",
    description: "Comfortable cotton t-shirt with cute cat design",
    price: 24.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/GQmKI9Nf0.png?output-format=jpg&downsize=650:*&output-format=auto&output-quality=auto",
    category: "clothing",
    stock: 50,
  },
  {
    id: "2",
    name: "Cat Ears Headband",
    description: "Adorable cat ears headband for cat lovers",
    price: 12.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/3sKq-cg3fH.png?crop=1115:1012;0,175&downsize=650:*&output-format=auto&output-quality=auto",
    category: "accessories",
    stock: 30,
  },
  {
    id: "3",
    name: "Cat Bed Deluxe",
    description: "Soft and cozy bed for your feline friend",
    price: 39.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/2QVaqbfuN.png?output-format=jpg&downsize=650:*&output-format=auto&output-quality=auto",
    category: "toys",
    stock: 20,
  },
  {
    id: "4",
    name: "Cat Toy Set",
    description: "Set of 5 interactive cat toys including bells and mice",
    price: 15.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/afZ-95sQ0.png?crop=1200:1237;0,0&downsize=650:*&output-format=auto&output-quality=auto",
    category: "toys",
    stock: 45,
  },
  {
    id: "5",
    name: "Cat Bowl Set",
    description: "Ceramic food and water bowl set with cute paw prints",
    price: 19.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/8kX3dmXRw.png?crop=952:1302;109,82&downsize=350:*&output-format=auto&output-quality=auto",
    category: "accessories",
    stock: 25,
  },
  {
    id: "6",
    name: "Cat Hoodie",
    description: "Warm and stylish hoodie with cat ears on the hood",
    price: 34.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/vIExuezj3H.png?output-format=jpg&downsize=650:*&output-format=auto&output-quality=auto",
    category: "clothing",
    stock: 35,
  },
  {
    id: "7",
    name: "Catnip Mouse Pack",
    description: "Pack of 3 catnip-filled toy mice",
    price: 9.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/VhtiIRJvL.png?crop=766:1254;0,205&downsize=350:*&output-format=auto&output-quality=auto",
    category: "toys",
    stock: 60,
  },
  {
    id: "8",
    name: "Cat Scratching Post",
    description: "Durable sisal rope scratching post with platform",
    price: 29.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/j-VGs78iV.png?output-format=jpg&downsize=650:*&output-format=auto&output-quality=auto",
    category: "furniture",
    stock: 15,
  },
  {
    id: "9",
    name: "Cat Phone Case",
    description: "Protective phone case with cute cat pattern",
    price: 19.99,
    imageUrl:
      "https://img.buzzfeed.com/buzzfeed-static/static/2019-08/20/21/asset/3b98acdac508/sub-buzz-720-1566336047-1.jpg?crop=955:1340;95,170&downsize=350:*&output-format=auto&output-quality=auto",
    category: "accessories",
    stock: 40,
  },
  {
    id: "10",
    name: "Cat Backpack",
    description: "Spacious backpack with cat face design",
    price: 44.99,
    imageUrl:
      "https://img.buzzfeed.com/store-an-image-prod-us-east-1/aWY0Kj5qz.png?crop=867:821;365,123&downsize=350:*&output-format=auto&output-quality=auto",
    category: "accessories",
    stock: 25,
  },
];
